<template>
  <div :class="className">
    <slot />
  </div>
</template>

<script>

export default {
  name: 'HeaderBar',

  props: {
    color: String,

    sticky: Boolean
  },

  computed: {
    className () {
      return [
        this.color,
        { 'sticky top-0': this.sticky }
      ]
    }
  }
}

</script>

<style>

.dull {
  @apply
    bg-white
    border-0
    border-b
    border-solid
    border-dull;
}

.primary {
  @apply bg-primary;
}

.primary-dark {
  @apply bg-primary-dark;
}

.secondary {
  @apply bg-secondary;
}

.secondary-dark {
  @apply bg-secondary-dark;
}

</style>
